var _rect, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3.22 13.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "toggle",
    x: -592.41,
    y: -303.06,
    width: 1280,
    height: 1040
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentcolor",
    cx: 1.61,
    cy: 1.61,
    r: 1.61
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "currentcolor",
    cx: 1.61,
    cy: 6.98,
    r: 1.61
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "currentcolor",
    cx: 1.61,
    cy: 12.35,
    r: 1.61
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggle);
export default __webpack_public_path__ + "static/media/toggle.9bed0deea708aaf529c8d8ff8e05b88d.svg";
export { ForwardRef as ReactComponent };